import React from 'react';
import cs from 'classnames';
import {connect} from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import {push as changeURL} from 'react-router-redux';

import EndingPage from '~/components/pages/EndingPage';
import store from '~/store';
import mapDispatch from '~/misc/mapDispatch';
import {
  getDirectOrderInfo,
  getPaymentInfo,
  createPayOrderAction,
} from '~/modules/customerServicePaymentProcess/actions';
import Spinner from '~/components/common/Spinner';
import {getUrlQeury} from '~/misc/formatUrlquery';

import css from '~/components/pages/PendingPayment/index.css';
import sharedCSS from '~/components/shared.css';
import accountPageCss from '~/components/pages/MyAccount/share.css';

class CreatePendingPayment extends React.Component {
  constructor(props) {
    super(props);
    this.jugdeRoute = this.jugdeRoute.bind(this);
  }

  componentWillMount() {
    const orderId = getUrlQeury() ? getUrlQeury().order_id : '';
    const ID = getUrlQeury() ? getUrlQeury().ID : '';
    const {paymentOrderInfo} = this.props.customerServicePaymentProcess;

    store.dispatch((dispatch, getState) => getDirectOrderInfo(dispatch, getState, ID));
    if (!orderId) {
      return this.props.gotoCreateAccount();
    }

    if (paymentOrderInfo.data && paymentOrderInfo.data.memberPlan !== 'Free') {
      return this.props.gotoRoot();
    }

    return null;
  }

  componentWillReceiveProps(nextProps) {
    if (isEmpty(this.props.customerServicePaymentProcess.paymentOrderInfo.data)
      && !isEmpty(nextProps.customerServicePaymentProcess.paymentOrderInfo.data)) {
      if (nextProps.customerServicePaymentProcess.paymentOrderInfo.data.memberPlan !== 'Free') {
        return this.props.gotoRoot();
      }
      return this.jugdeRoute();
    }
    if (isEmpty(this.props.customerServicePaymentProcess.payInfo.data)
    && !isEmpty(nextProps.customerServicePaymentProcess.payInfo.data)) {
      return this.props.goToResult();
    }
    return null;
  }

  render() {
    return (
      <div className={cs(sharedCSS.widewrap, 'pay-content')}>
        <div className={cs(sharedCSS.wideStretchable, css.wrap)}>
          <div className={cs(css.content)}>
            { this.renderContent(this.props.customerServicePaymentProcess) }
          </div>
        </div>
      </div>
    );
  }

  renderContent(pageInfo) {
    const {orderPaymentInfo, payInfo} = pageInfo;
    const pageData = Array.isArray(orderPaymentInfo.data) ? orderPaymentInfo.data[0] : orderPaymentInfo.data;
    if (orderPaymentInfo.error) {
      return (
        <div className={cs(accountPageCss.viewH, css.center)} onClick={this.jugdeRoute}>
          {orderPaymentInfo.error}
        </div>
      );
    }

    if (!isEmpty(orderPaymentInfo.data) && pageData.status !== 'success_paid') {
      // const productMount = pageData.product.total ? pageData.product.total : 0;
      return (
        <div>
          <EndingPage
            payInfo={payInfo}
            user={this.props.user}
            query={getUrlQeury()}
            account={this.props.account}
            orderInfo={pageData}
            type='pending'
            actionFn={createPayOrderAction}
          />
        </div>
      );
    }
    return (
      <div className={sharedCSS.viewH}>
        <div className={cs(accountPageCss.spinnerLine)}>
          <div className={cs(accountPageCss.spinner, css.marginCenter)}>
            <Spinner scalable={true}/>
          </div>
        </div>
      </div>
    );
  }

  jugdeRoute() {
    const query = getUrlQeury();
    if (!isEmpty(query) && query.order_id) {
      store.dispatch((dispatch, getState) => getPaymentInfo(dispatch, getState, query));
      this.setState({
        query: query,
      });
    }
  }
}

export default connect(({user, routing, customerServicePaymentProcess}) => (
  {user, routing, customerServicePaymentProcess}
), mapDispatch({
  gotoCreateAccount: () => changeURL('/create-account'),
  goToResult: () => changeURL('/create-payment-result'),
  gotoRoot: () => changeURL('/'),
}))(CreatePendingPayment);



// WEBPACK FOOTER //
// ./src/components/pages/CreateAccount/CreatePendingPayment/index.js